module.exports = "//public.getcloudapp.com/packs/media/images/1-2069108911bb9ec5f48dd27c080b95d7.png";